import { Controller } from "@hotwired/stimulus"
import { showElement, hideElement } from "../helpers/dom_helpers"

export default class extends Controller {
  static targets = [
    "copyButton",
    "downloadLink",
    "exactPanel",
    "exactTab",
    "normalizedPanel",
    "normalizedTab",
    "timestamps"
  ]
  static values = {
    text: String,
    timestampedText: String
  }

  connect() {
    this.#syncTimestampOptions()
  }

  showNormalized() {
    this.#showPanel("normalized")
  }

  showExact() {
    this.#showPanel("exact")
  }

  toggleTimestamps() {
    this.#syncTimestampOptions()
  }

  #showPanel(panel) {
    const normalized = panel === "normalized"

    if (this.hasNormalizedPanelTarget) {
      normalized ? showElement(this.normalizedPanelTarget) : hideElement(this.normalizedPanelTarget)
    }

    if (this.hasExactPanelTarget) {
      normalized ? hideElement(this.exactPanelTarget) : showElement(this.exactPanelTarget)
    }

    if (this.hasNormalizedTabTarget) this.#setTabState(this.normalizedTabTarget, normalized)
    if (this.hasExactTabTarget) this.#setTabState(this.exactTabTarget, !normalized)
  }

  #syncTimestampOptions() {
    const includeTimestamps = this.hasTimestampsTarget && this.timestampsTarget.checked

    if (this.hasCopyButtonTarget) {
      this.copyButtonTarget.dataset.copyText = includeTimestamps ? this.timestampedTextValue : this.textValue
    }

    this.downloadLinkTargets.forEach((link) => {
      link.href = includeTimestamps ? link.dataset.timestampPath : link.dataset.path
    })
  }

  #setTabState(tab, active) {
    if (!tab) return

    tab.classList.toggle("active", active)
    tab.classList.toggle("stub-primary-soft", active)
    tab.classList.toggle("border", active)
    tab.classList.toggle("stub-link", !active)
  }
}
